import React from 'react';
import cx from 'classnames';
import './Section.scss';

const SectionPlain = ({ children, className, title, subTitle, body, titleH2, textCenter }) => (
  <div
    className={cx({
      section: true,
      'section--top-padding-h1': !titleH2,
      'section--text-center': textCenter,
      [className]: className,
    })}
  >
    {title ? (
      <div className="section__content-wrapper">
        {subTitle && (
          <label
            data-sal="slide-right"
            data-sal-easing="ease"
            data-sal-delay="50"
            className="label"
          >
            {subTitle}
          </label>
        )}
        {titleH2 ? (
          <h2
            className="h2 h2--margin-bottom-48"
            data-sal="slide-right"
            data-sal-easing="ease"
            data-sal-delay="100"
          >
            {title}
          </h2>
        ) : (
          <h1 data-sal="slide-right" data-sal-easing="ease" data-sal-delay="100">
            {title}
          </h1>
        )}
        {body && (
          <p
            className="body-1 body-1--no-margin"
            data-sal="slide-right"
            data-sal-easing="ease"
            data-sal-delay="150"
          >
            {body}
          </p>
        )}
      </div>
    ) : null}
    {children}
  </div>
);

export default SectionPlain;
